import { VaultDocument } from '@syfo/types/vault.types';
import type { ClientProfile } from '@syfo/types/api.client.types';

export interface VaultInfo {
  id: string;
  name: string;
}

export interface VaultMeta {
  info: VaultInfo;
  syncState: VaultSyncState;
  isSyncEnabled: boolean; // true if vault.[id].sync = "true" in localStorage
  isOwned?: boolean; // true = synced vault owned by user, false = shared with user, undefined = local only
}

export interface VaultBlob {
  info: VaultInfo;
  document: VaultDocument;
}

export interface VaultSyncState {
  lastSyncDate: string;
  lastChangeDate: string;
  serverLastModified?: string; // Server's Last-Modified date for conditional writes (If-Unmodified-Since)
  syncId?: string; // Server-assigned vault ID for sync operations (differs from client vaultId)
}

export interface VaultState {
  info: VaultInfo;
  syncState: VaultSyncState;
  data: VaultDocument;
}

export enum ShadeMode {
  Light,
  Dark
}

export interface AuthState {
  isAuthenticated: boolean | null; // null = loading, false = not authenticated, true = authenticated
  userProfile: ClientProfile | null;
  sessionExpired: boolean;
}

export interface VaultDeletedInfo {
  message: string;
  vaultId: string;
}

// Define the initial state
export interface SyfoAppState {
  mode: ShadeMode;
  currentVault: VaultState | null;
  vaults: VaultMeta[];
  auth: AuthState;
  /** Set when a vault sync detects the vault has been deleted on the server. */
  deleted: VaultDeletedInfo | null;
  /** True while listVaultsThunk is in flight; false once resolved or rejected */
  isLoadingVaults: boolean;
}